import { MAJOR_POLICE_TYPES } from "./constants";

export function alarmColor(level) {
  const n = parseInt(level) || 0;
  if (n >= 3) return { bg: "#7f1d1d", text: "#fca5a5" };
  if (n === 2) return { bg: "#431407", text: "#fb923c" };
  if (n === 1) return { bg: "#dcfce7", text: "#166534" };
  return { bg: "#f1f5f9", text: "#64748b" };
}

export function fmtTime(ms) {
  if (!ms) return "—";
  return new Date(ms).toLocaleTimeString("en-CA", { hour: "2-digit", minute: "2-digit", hour12: false });
}

export function fmtDate(ms) {
  if (!ms) return "";
  const d = new Date(ms);
  if (d.toDateString() === new Date().toDateString()) return "";
  return d.toLocaleDateString("en-CA", { month: "short", day: "numeric" });
}

export function cleanType(type) {
  return type?.replace(/\s*just occurred\s*/gi, "").trim();
}

export function isMajorPolice(type) {
  return MAJOR_POLICE_TYPES.some(t => cleanType(type)?.toUpperCase().includes(t));
}

export function isMajorFire(level) {
  return parseInt(level) >= 2;
}
